module.exports = __webpack_public_path__ + "assets/img/return.b2ce963a.png";